// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-modal_wrapper__0NYQh","errorItem":"error-modal_errorItem__OOZSX","validationErrorTitle":"error-modal_validationErrorTitle___u3pG"};